
// src/services/marketData/providers/alphaVantage.provider.ts
import { MarketDataProvider } from '../provider.interface';
import { alphaVantageClient } from '../../alphaVantage/client';

export class AlphaVantageProvider implements MarketDataProvider {
  getName(): string {
    return 'Alpha Vantage';
  }
  
  async getTimeSeriesDaily(symbol: string): Promise<any> {
    return alphaVantageClient.fetchTimeSeriesDaily(symbol);
  }
  
  async getTimeSeriesIntraday(symbol: string, interval: string): Promise<any> {
    return alphaVantageClient.fetchIntraday(symbol, interval);
  }
  
  async getQuote(symbol: string): Promise<any> {
    // Simple implementation that extracts the latest quote from daily data
    const dailyData = await this.getTimeSeriesDaily(symbol);
    const timeSeriesData = dailyData['Time Series (Daily)'];
    
    if (!timeSeriesData) {
      throw new Error('Could not retrieve quote data');
    }
    
    // Get the most recent date
    const dates = Object.keys(timeSeriesData).sort().reverse();
    if (dates.length === 0) {
      throw new Error('No quote data available');
    }
    
    const latestData = timeSeriesData[dates[0]];
    
    return {
      symbol,
      date: dates[0],
      price: parseFloat(latestData['4. close']),
      open: parseFloat(latestData['1. open']),
      high: parseFloat(latestData['2. high']),
      low: parseFloat(latestData['3. low']),
      volume: parseInt(latestData['5. volume'], 10)
    };
  }
}
